<template>
  <div>
    <table border="1">
        <caption>授权前行为</caption>
      <tr>
        <td>行为阶段</td>
        <td>主体类型</td>
        <td>主体名称</td>
        <!-- <td>行为名称</td> -->
        <td>官方说明或隐私政策</td>
      </tr>

      <!-- <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>腾讯SDK</td>
        <td>获取设备传感器</td>
        <td>
          <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">点击查看</a>
        </td>
  
      </tr> -->

      <!-- <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>腾讯SDK</td>
        <td>获取MAC地址</td>
        <td>
          <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">点击查看</a>
        </td>
      </tr> -->
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>腾讯SDK</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">点击查看</a>
        </td>
      </tr>
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>支付宝</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://opendocs.alipay.com/open/54">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>微信支付</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://privacy.qq.com/policy/tencent-privacypolicy">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>微信</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy">点击查看</a>
        </td>
      </tr>
      <!-- <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>微博</td>
        <td>获取应用安装列表、获取设备传感器、获取MAC地址</td>
        <td>
          <a href="https://open.weibo.com/wiki/Android_SDK%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3">点击查看</a>
        </td>
      </tr> -->
      
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>QQ</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://wiki.connect.qq.com">点击查看</a>
        </td>
      </tr>

      <!-- <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>环信IM</td>
        <td>获取应用安装列表、获取设备传感器、获取MAC地址</td>
        <td>
          <a href="https://www.easemob.com/protocol">点击查看</a>
        </td>
      </tr> -->

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>中国移动</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://wap.cmpassport.com/resources/html/contract.html">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>中国电信</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://e.189.cn/sdk/agreement/detail.do">点击查看</a>
        </td>
      </tr>
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>中国联通</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?fromsdk=true">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>阿里云号码认证</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.727039ebkw36o8">点击查看</a>
        </td>
      </tr>

      <!-- <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>阿里百川</td>
        <td>获取应用安装列表、获取设备传感器、获取MAC地址</td>
        <td>
          <a href="https://terms.alicdn.com/legal-agreement/terms/suit_bu1_taobao/suit_bu1_taobao202107141244_11649.html?spm=a3c0d.7629140.1998907877.3.72bfbe481LC0vf">点击查看</a>
        </td>
      </tr> -->

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>高德开放平台定位SDK</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://lbs.amap.com/pages/privacy/">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>极光Sdk</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://www.jiguang.cn/license/privacy">点击查看</a> 
        </td>
      </tr>
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>华为推送</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://consumer.huawei.com/cn/privacy/privacy-policy/">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>OPPO推送</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://open.oppomobile.com/wiki/doc#id=10288">点击查看</a> 
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>vivo推送</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://dev.vivo.com.cn/documentCenter/doc/366">点击查看</a>
        </td>
      </tr>
      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>小米推送</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://dev.vivo.com.cn/documentCenter/doc/366">点击查看</a>
        </td>
      </tr>

      <tr>
        <td>授权前行为</td>
        <td>SDK</td>
        <td>魅族推送</td>
        <!-- <td>获取应用安装列表、获取设备传感器、获取MAC地址</td> -->
        <td>
          <a href="https://www.flyme.cn/agreement">点击查看</a> 
        </td>
      </tr>
     
   
  
     
    
    
      
    </table>
  </div>
</template>

<script>
export default {
    name:'behavior',
    data(){
        return{

        }
    },
    created () {
      document.title = '授权前行为清单'
    },

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/behavior.vue